import React, { useState } from "react";
import CustomModal from "../components/modal/CustomModal";

const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };


  const ModalComponent = ({ title, body, actions, onCloseCustom, isCustomClose = false }) => (
    <CustomModal
      isOpen={isOpen}
      onClose={onCloseCustom ? onCloseCustom : closeModal}
      title={title}
      body={body}
      actions={actions}
      isCustomClose={false}
    />
  );

  return [ModalComponent, openModal, closeModal];
};

export default useModal;
